import createLucideIcon from '../createLucideIcon';

/**
 * @component @name SunMoon
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnYyIiAvPgogIDxwYXRoIGQ9Ik0xMyA4LjEyOUE0IDQgMCAwIDEgMTUuODczIDExIiAvPgogIDxwYXRoIGQ9Im0xOSA1LTEuMjU2IDEuMjU2IiAvPgogIDxwYXRoIGQ9Ik0yMCAxMmgyIiAvPgogIDxwYXRoIGQ9Ik05IDhhNSA1IDAgMSAwIDcgNyA3IDcgMCAxIDEtNy03IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/sun-moon
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const SunMoon = createLucideIcon('sun-moon', [
  ['path', { d: 'M12 2v2', key: 'tus03m' }],
  ['path', { d: 'M13 8.129A4 4 0 0 1 15.873 11', key: 'my0cn3' }],
  ['path', { d: 'm19 5-1.256 1.256', key: '1yg6a6' }],
  ['path', { d: 'M20 12h2', key: '1q8mjw' }],
  ['path', { d: 'M9 8a5 5 0 1 0 7 7 7 7 0 1 1-7-7', key: '4qob92' }],
]);

export default SunMoon;
